var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0769 16.8077V19.2692C15.0769 19.5957 14.9473 19.9087 14.7164 20.1395C14.4856 20.3703 14.1726 20.5 13.8462 20.5H5.23077C4.90435 20.5 4.5913 20.3703 4.36048 20.1395C4.12967 19.9087 4 19.5957 4 19.2692V5.73077C4 5.40435 4.12967 5.0913 4.36048 4.86048C4.5913 4.62967 4.90435 4.5 5.23077 4.5H13.8462C14.1726 4.5 14.4856 4.62967 14.7164 4.86048C14.9473 5.0913 15.0769 5.40435 15.0769 5.73077V8.19231",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3838 12.5H19.9992",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5381 10.0385L19.9996 12.5L17.5381 14.9616",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLogout;